<template>
  <div>
    <v-card v-for="(item, index) in value" :key="index" class="my-3">
      <h4 class="mr-2">{{ item.block_heading }}</h4>
      <v-divider></v-divider>
      <BlockItem
        :ref="`formSections${index}`"
        :value.sync="item.definitions"
        :itemId="itemId"
        :model="model"
        :disabled="disabled"
        @input="setFilled"
        @save="save(true)"
      />
    </v-card>
  </div>
</template>

<script>
import BlockItem from './BlockItem.vue'

export default {
  components: {
    BlockItem,
  },
  props: {
    itemId: {
      required: true,
      type: Number,
    },
    model: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: Array,
    },
    filled: {
      required: false,
      type: Boolean,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setFilled() {
      // console.log('set filled called')
      let filled = this.value.every(block => {
        return block.definitions.every(field => {
          if (!field.required && !field.data_info?.required_if_relation) return true
          // if (field.data_info?.relation) {
          //   for (let key in field.data_info.relation) {
          //     let related = block.definitions.find(d => d.id == key)
          //     if (related.value != field.data_info.relation[key]) return true
          //     console.log(field.value)
          //   }
          // }
          if (field.data_info?.required_if_relation) {
            for (let key in field.data_info.required_if_relation) {
              let related = block.definitions.find(d => d.id == key)
              if (!related) {
                alert('Undefined related field')
                return false
              }
              let cmp = field.data_info.required_if_relation[key].compare || 'eq'
              switch (cmp) {
                case 'eq':
                  if (related.value != field.data_info.required_if_relation[key].value)
                    return true
                  break
                case 'in':
                  if (!field.data_info.required_if_relation[key].value.includes(related.value))
                    return true
                  break
                default:
                  alert('Undefined comparision type')
                  return false
              }
            }
          }
          switch (field.data_type) {
            case 'editor':
              return field.value != null && field.value != '<p></p>'
            case 'select':
            case 'radio':
            case 'file':
            case 'datepicker':
              return field.value != null
            case 'checkbox':
              return !!field.value
            default:
              return false
          }
        })
      })
      this.$emit('update:filled', filled)
      return filled
    },
    async save(force = false) {
      if (!force && (!this.filled || this.disabled)) return
      let data = {
        model: this.model,
        id: this.itemId,
        blocks: this.value,
      }

      // TODO: if file, upload

      return this.$axios.post(`/api/form-blocks`, data)
    },
  },
  mounted() {
    this.setFilled()
  },
}
</script>